Selector.View.LandscapeView = Backbone.View.extend(
/** @lends Selector.View.LandscapeView# */
{
    el: $("#landscapeWindow div"),

    d3circle : null,

    initialize: function() {

        _.bindAll(this, "render");
        this.collection.on('reset',this.render);
        this.collection.on('change',this.render);

        //
        // this.d3circle = d3.selectAll("circle");

    },

    /** Render function */
    render: function() {

        this.$el.html("");

        let fragment = document.createDocumentFragment(),
            initLeft = 50,
            initBottom = 11,//these are the initial starting pos
            maxDistanceLeft = 0,
            maxDistanceBottom = 0,
            answer;

        this.collection.each(function (model) {
            if (model.get("ANSWER") !== null) {
                answer = _.find(model.get("ANSWERS"), function (obj) { return obj.VALUE === model.get("ANSWER"); });
                if (answer !== undefined && answer.IMAGE !== undefined && answer.IMAGE !== "") {
                    var images = JSON.parse(answer.IMAGE);
                    for (var i = 0; i < images.length; i++) {
                        var data = images[i];

                        //display on web page
                        var img = document.createElement("img");
                        img.src = "/common/images/landscape/items/" + data.url;
                        img.style.cssText = "left: " + data.pos[0] + "%; bottom: " + data.pos[1] + "%; width: " + data.width + "px;";

                        //work out distance from start point to calculate reveal circle
                        //left/bottom points
                        maxDistanceLeft =  Math.max(maxDistanceLeft, Math.abs(initLeft - data.pos[0]));
                        maxDistanceBottom = Math.max(maxDistanceBottom, Math.abs(initBottom - data.pos[1]));

                        //right point, which has to calculate width of item as a percentage
                        maxDistanceLeft = Math.max(maxDistanceLeft, Math.abs(initLeft - (data.pos[0] + ((data.width/this.$el.width()) * 100))));
                        fragment.appendChild(img);
                    }
                }
            }
        }, this);

        _.debounce(this.resizeCircle(Math.max(maxDistanceLeft, maxDistanceBottom)), 100);

        this.$el.html(fragment);

        return this;
    },

    resizeCircle: function(radius) {
        if (radius > 0) radius += 3; //little bit bigger as a nice frame
        if (radius >= 45) radius = 100; //if it's big enough, just reveal the whole thing.

        //this.d3circle
        //    .transition()
        //    .duration(1000)
        //    .attr("r", radius);
    }
});